import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SizeDataService {
  constructor(private api: ApiService) {}
  private baseUrl = environment.apiUrl;

  productSizeTable(productId: string): Observable<any> {
    return this.api.get<any>(
      `${this.baseUrl}/SizeData/ProductSizeTable?productId=${productId}`
    )
  }
    
  variantSizeTable(variantId: string): Observable<any> {
    return this.api.get<any>(
      `${this.baseUrl}/SizeData/VariantSizeTable?productId=${variantId}`
    );
  }

  valueHash(entityType: string, entityId: string): Observable<string> {
    return this.api.get<string>(
      `${this.baseUrl}/SizeData/ValueHash?entityType=${entityType}&entityId=${entityId}`
    );
  }
}